import * as z from 'zod';
import { companyCreditReportVendorSchema, companyCreditReportFailureReasonSchema } from '../../enums.mjs';
import '../../types/actor/actor.mjs';
import '../../types/address/address.mjs';
import { Vendor as Vendor$1 } from '../../types/credit-report/company-credit-report.mjs';
import '../../types/credit-report/individual-credit-report.mjs';
import '../../types/currency/currency.mjs';
import '../../types/entityRelation/entity-relation.mjs';
import '../../types/financial-formula/adjustable-value.mjs';
import '../../types/financial-formula/adjustable-values-update.mjs';
import '../../types/financial-formula/adjustment.mjs';
import '../../types/financial-formula/formula.mjs';
import '@inrev/core';
import '../../types/is-encrypted.mjs';
import '../../types/naics-codes/naics-codes.mjs';
import { isoDateTimeSchema, companyContactId, companyCreditReportId } from '../../types/opaque.mjs';
import '../../types/surety/account/surety-account.types.mjs';
import '../../types/surety/application-extraction/application-extraction-output.mjs';
import '../../types/surety/application-extraction/application-extraction-webhook.mjs';
import '../../types/surety/bond/surety-bond.types.mjs';
import '../../types/surety/bond-form/issued/issued-surety-bond-form.types.mjs';
import '../../types/surety/bond-form/surety-bond-form.data.mjs';
import '../../types/surety/bond-request/bond-request-extraction-output.mjs';
import '../../types/surety/bond-request/bond-request-extraction-webhook.mjs';
import '../../types/surety/contract/contract-extraction-output.mjs';
import '../../types/surety/contract/contract-extraction-webhook.mjs';
import '../../types/surety/financial-statement/financial-period/balance-sheet-data.mjs';
import '../../types/surety/financial-statement/financial-period/financial-period-extraction-webhook.mjs';
import '../../types/surety/financial-statement/financial-period/income-statement-data.mjs';
import '../../types/surety/financial-statement/financial-period/income-statement-fields.mjs';
import '../../types/surety/financial-statement/financial-period/income-statement-with-adjustments.mjs';
import '../../types/surety/financial-statement/financial-period/line-item-group.mjs';
import '../../types/surety/financial-statement/financial-period/section-keys.mjs';
import '../../types/surety/financial-statement/financial-period/statement-metadata.mjs';
import '../../types/surety/financial-statement/financial-period/view-shapes.mjs';
import '../../types/surety/financial-statement/financial-statement-schemas.mjs';
import '../../types/surety/indemnity/indemnity-agreement.mjs';
import '../../types/surety/quote/surety-quote.types.mjs';
import '../../types/surety/wip-schedule/wip-schedule-data.mjs';
import '../../types/surety/wip-schedule/wip-schedule-extraction-webhook.mjs';
import '../../types/surety/work-in-progress-statement/surety-work-in-progress-statement.mjs';
import '../../types/user/user.types.mjs';
import '../../types/utils.mjs';

var Vendor;
(function (Vendor) {
    const vendorMetaSchema = {
        vendor: companyCreditReportVendorSchema.optional(),
        experianPremierProfile: z.unknown().nullish(),
    };
    Vendor.responseSchema = z.union([
        z.object({
            success: z.literal(false),
            ...vendorMetaSchema,
        }),
        z.object({
            success: z.literal(true),
            fileFound: z.literal(false),
            ...vendorMetaSchema,
        }),
        z.object({
            success: z.literal(true),
            fileFound: z.literal(true),
            report: Vendor$1.reportSchema,
            ...vendorMetaSchema,
        }),
    ]);
})(Vendor || (Vendor = {}));
var Admin;
(function (Admin) {
    (function (Response) {
        Response.schema = z.object({
            id: companyCreditReportId,
            success: z.boolean(),
            failureReason: companyCreditReportFailureReasonSchema.optional(),
            creditProfile: Vendor$1.creditProfileSchema,
            yearsInBusinessOrCreditAge: z.number().nonnegative().optional(),
            companyContactId: companyContactId,
            createdAt: isoDateTimeSchema,
            updatedAt: isoDateTimeSchema,
        });
    })(Admin.Response || (Admin.Response = {}));
})(Admin || (Admin = {}));

export { Admin, Vendor };
